module.exports = __webpack_public_path__ + "static/media/bet-orange-5.8d7348d0.png";